var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.1777C1.5 1.80342 1.80342 1.5 2.1777 1.5H7.57839C7.75813 1.5 7.9305 1.5714 8.0576 1.69849L16.3015 9.9424C16.5662 10.2071 16.5662 10.6362 16.3015 10.9008L10.9008 16.3015C10.6362 16.5662 10.2071 16.5662 9.9424 16.3015L1.69849 8.05759C1.5714 7.9305 1.5 7.75813 1.5 7.57839V2.1777Z",
    stroke: "#A0AEC0",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38857 5.12202C6.38857 5.82152 5.82152 6.38857 5.12202 6.38857C4.42252 6.38857 3.85547 5.82152 3.85547 5.12202C3.85547 4.42252 4.42252 3.85547 5.12202 3.85547C5.82152 3.85547 6.38857 4.42252 6.38857 5.12202Z",
    stroke: "#A0AEC0",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/table_icon.ee34028f8c437a391698ada4e6bbba37.svg";
export { ForwardRef as ReactComponent };